import React from 'react';
import {Typography, Box, useTheme} from '@mui/material';
import CustomButton from './Button';
import {SD_BUTTON_RADIUS} from '../../constants/ui-tokens';

const FormWrapper = ({children, headingTextColor, subHeadingText = {text: null, onClick: () => {}}, headingText = '', buttonInputs = [], loading, disabled}) => {
  const theme = useTheme();
  const defaultTextColor = theme.palette.text.primary; // Default to the theme's text color

  return (
    <Box display="flex" flexDirection="column" height="100%" width="100%" paddingLeft="0" paddingRight="0">
      <form autoComplete="off" autoSave="off">
        <Box mt={1}>
          <Typography variant="h1" fontSize={30} mb={1} color={headingTextColor || defaultTextColor}>
            {headingText}
          </Typography>
          {subHeadingText.text && (
            <Typography variant="body2" onClick={subHeadingText.onClick} style={{cursor: 'pointer', paddingBottom: 10}}>
              {subHeadingText.text}
            </Typography>
          )}
        </Box>
        <Box overflow="hidden" mt={2}>
          {children}
        </Box>
        {buttonInputs.map((button, index) => {
          if (button.hide) {
            return null;
          }
          return (
            <CustomButton
              visible={button?.visible}
              disabled={disabled}
              type={button?.type}
              key={index}
              text={button?.text}
              onClick={button.onClick}
              loading={loading}
              width={button?.width}
              borderRadius={button?.borderRadius ?? SD_BUTTON_RADIUS}
              height={button?.height}
              marginBlock={button?.marginBlock}
            />
          );
        })}
      </form>
    </Box>
  );
};

export default FormWrapper;
